import React from 'react'
import styled from '@emotion/styled/macro'
import { useTranslation } from 'react-i18next'
import mq from 'mediaQuery'

import Years from './NameRegister/Years'
import Price from './NameRegister/Price'
import EthRegistrationGasPrice from './NameRegister/EthRegistrationGasPrice'
import { ReactComponent as DefaultOrangeExclamation } from '../Icons/OrangeExclamation.svg'
import { ReactComponent as ChainDefault } from '../../assets/icon-chain.svg'
import Polygon from '../../assets/icon-polygon.svg'

const PricingContainer = styled('div')`
  display: flex;
  margin-bottom: 15px;
  flex-direction: column;

  ${mq.medium`
    flex-direction: row;
    margin-bottom: 30px;
  `}
`

const Chain = styled(ChainDefault)`
  width: 24px;
  height: 24px;
  margin: 12px 20px 0;
  display: none;

  ${mq.medium`
    display: block;
  `}
`

const Prompt = styled('div')`
  font-size: 12px;
  color: #fff;
  margin-bottom: 10px;
  background: #ff5b00;
  border-radius: 52px;
  display: inline-block;
  padding: 6px 20px;
  position: relative;
  margin-bottom: 26px;
`

const IconPolygon = styled('div')`
  position: absolute;
  top: 100%;
  left: 12px;
  background: url(${Polygon}) no-repeat;
  width: 12px;
  height: 15px;
`

function PricerInner({
  years,
  setYears,
  duration,
  ethUsdPriceLoading,
  ethUsdPrice,
  ethUsdPremiumPrice,
  className,
  loading,
  price,
  premiumOnlyPrice,
  gasPrice,
  reference,
  underPremium,
  displayGas = false
}) {
  const { t } = useTranslation()
  return (
    <>
      {/* {years <= 1 && (
        <Prompt>
          <IconPolygon />
          {t('register.increaseRegistrationPeriod')}
        </Prompt>
      )} */}

      <PricingContainer className={className} ref={reference}>
        <Years years={years} setYears={setYears} />
        <Chain />
        <Price
          price={price}
          premiumOnlyPrice={premiumOnlyPrice}
          gasPrice={gasPrice}
          loading={loading}
          ethUsdPriceLoading={ethUsdPriceLoading}
          ethUsdPrice={ethUsdPrice}
          ethUsdPremiumPrice={ethUsdPremiumPrice}
          underPremium={underPremium}
        />
      </PricingContainer>

      {displayGas && gasPrice && (
        <div>
          <EthRegistrationGasPrice
            price={price}
            gasPrice={gasPrice}
            loading={loading}
            ethUsdPriceLoading={ethUsdPriceLoading}
            ethUsdPrice={ethUsdPrice}
            ethUsdPremiumPrice={ethUsdPremiumPrice}
            underPremium={underPremium}
          />
        </div>
      )}
    </>
  )
}

export const PricerAll = React.forwardRef((props, reference) => {
  return <PricerInner reference={reference} {...props} />
})

const Pricer = React.forwardRef((props, reference) => {
  return <PricerInner reference={reference} {...props} />
})

export default Pricer
